export default __webpack_public_path__ + "static/media/kitchen.75875d41.jpg";